import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Warning } from '../shared/services/error-handling/error-types';

import { CLPBPStore } from '../store';
import { INCREMENT, DECREMENT, RESET } from './counter/counter.actions';

@Component({
  selector: 'ld-counter-example',
  templateUrl: './counter-example.component.html',
  styleUrls: ['./counter-example.component.css']
})
export class CounterExampleComponent implements OnInit {
  count: Observable<number>;

  constructor(private store: Store<CLPBPStore>, private errorHandler: ErrorHandler) {
    this.count = store.select<number>(s => s.count);

    this.count.subscribe(
      value => {
        try {
          if (value < 0) {
            throw new Error('Counter value was less than 0');
          }
          if (value === 2) {
            this.errorHandler.handleError(new Warning('Counter value was 2'));
          }
        } catch (error) {
          this.errorHandler.handleError(error);
        }
      },
      error => this.errorHandler.handleError(error),
      () => console.log('complete')
    );
  }

  increment() {
    this.store.dispatch({ type: INCREMENT });
  }

  decrement() {
    this.store.dispatch({ type: DECREMENT });
  }

  reset() {
    this.store.dispatch({ type: RESET });
  }

  throw() {
    throw new Error('Throw button was clicked');
  }

  ngOnInit() {
  }

}
